export function canSetEnrollmentGraduated(user) {
  return user?.role?.type === 'supervisor_admin';
}

/** Lock status dropdown when enrollment is already graduado and user cannot manage it. */
export function isEnrollmentStatusLocked(user, currentStatus) {
  return currentStatus === 'graduado' && !canSetEnrollmentGraduated(user);
}

/**
 * Builds enrollment update payload. Omits status when a non-supervisor saves
 * without changing away from graduado (avoids 403 when editing semester/group).
 */
export function withEnrollmentStatusForUpdate({ user, statusEnrollment, currentStatus, data }) {
  const payload = { ...data };

  if (canSetEnrollmentGraduated(user) || statusEnrollment !== 'graduado') {
    payload.status = statusEnrollment;
  }

  return payload;
}

export function isEnrollmentGraduatedForbidden(error) {
  return error?.response?.status === 403;
}
